import TarefasApi from './tarefa'

export const TarefaApi = {
  async delete(id) {
    return await TarefasApi.delete(id)
  },

  async deleteTaskList(taskIds, scheduleIds) {
    return await TarefasApi.deleteTaskList(taskIds, scheduleIds)
  },

  async completeOrResetTask(id, completed) {
    return await TarefasApi.completeOrResetTask(id, completed)
  },

  async completeOrResetTaskList(taskIds, completed) {
    return await TarefasApi.completeOrResetTaskList(taskIds, completed)
  },

  async updateEventDay(eventDay) {
    return await TarefasApi.updateEventDay(eventDay)
  }
}

export default TarefaApi
